/**
 * IDs globales de canción, arreglo y revisión (ADR 0003): aleatorios, con prefijo legible. El
 * dominio no genera IDs; los genera quien lo llama.
 */
export function newId(prefix: string): string {
  const bytes = new Uint8Array(9)
  crypto.getRandomValues(bytes)
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('')
  return `${prefix}_${hex}`
}
